import './App.css'
import { Provider as JotaiProvider } from 'jotai'
import { ThemeProvider } from 'styled-components'
import GlobalStyles from './components/GlobalStyles'
import { theme } from './components/Themes'
import Services from './components/services/Services'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'
import React, { useRef, useEffect, useState } from 'react'
import NavbarStyle from './components/nav/NavbarStyle'
import BackgroundWave from './images/waveTestPixSmall.svg'
import burgerMenu from './images/icons/burger-menu.svg'
import MobileDropdown from './components/nav/MobileDropdown'
import Intro from './components/intro/Intro'
import Games from './components/games/Games'
import icon from './images/Seaside-studios-icon.svg'
import LogoBox from './components/nav/LogoBox'
import AiData from './components/aiData/AiData'

// TODO:
// basic is ready to go, I plan to add more as more games come up, maybe even add a store.

function App() {
  const [scrolled, setScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const about = useRef(null)
  const services = useRef(null)
  const gamesRef = useRef(null)
  const contact = useRef(null)

  const scrollToSection = (elementRef) => {
    window.scrollTo({
      top: elementRef.current.offsetTop,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0
      setScrolled(isScrolled)
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  //if window height is greater than window width switch to mobile nav
  // console.log(window.innerHeight, window.innerWidth)

  return (
    <JotaiProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyles>
          <AiData />
          <NavbarStyle scrolled={scrolled}>
            {/* <img src={solarisWhite} alt="Solaris logo" className="logo" /> */}
            <LogoBox>
              <img src={icon} alt={'logo'} />
              <h1>Seaside Studios</h1>
            </LogoBox>
            {window.innerHeight < window.innerWidth && (
              <div className="d-flex">
                <p onClick={() => scrollToSection(about)} className="link">
                  About
                </p>
                <p onClick={() => scrollToSection(services)} className="link">
                  Services
                </p>
                <p onClick={() => scrollToSection(gamesRef)} className="link">
                  Games
                </p>
                <p onClick={() => scrollToSection(contact)} className="link">
                  Contact
                </p>
              </div>
            )}
            {window.innerHeight > window.innerWidth && (
              <>
                <img
                  src={burgerMenu}
                  alt="nav menu"
                  className="nav-burger"
                  onClick={toggleMobileMenu}
                />
              </>
            )}
          </NavbarStyle>
          {isMobileMenuOpen && (
            <MobileDropdown
              scrollToSection={scrollToSection}
              about={about}
              partners={gamesRef}
              services={services}
              contact={contact}
              scrolled={scrolled}
              setIsMobileMenuOpen={setIsMobileMenuOpen}
              isMobileOpen={isMobileMenuOpen}
            />
          )}

          <img
            src={BackgroundWave}
            alt="Background Wave"
            className="brand-mark"
          />

          <div ref={about}>
            <Intro scrollToSection={scrollToSection} contact={services} />
          </div>
          <div ref={services} className="services">
            <Services />
          </div>
          <div ref={gamesRef}>
            <Games />
          </div>
          <div ref={contact} className="contact">
            <Contact />
          </div>
          <Footer />
          {/* <p>just for fun info here</p> */}
        </GlobalStyles>
      </ThemeProvider>
    </JotaiProvider>
  )
}

export default App
